export default __webpack_public_path__ + "static/media/hero.570ab462.mp4";